/**
 * Fly-out panel toggle helper
 * Toggles body class when fly-out panel toggle buttons are clicked
 */

class FlyOutPanelToggle {
  constructor() {
    this.bodyClass = 'fly-out-panel-open';
    this.toggleSelector = '.js-fly-out-panel-toggle';
    this.panelSelector = '.js-fly-out-panel';
    this.activeClass = 'active';
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const toggleButton = e.target.closest(this.toggleSelector);
      if (toggleButton) {
        e.preventDefault();
        this.togglePanel(toggleButton);
      }
    });

    // Close panel when clicking outside or pressing escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains(this.bodyClass)) {
        this.closePanel();
      }
    });

    // Close panel when clicking on overlay
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('js-fly-out-panel') && document.body.classList.contains(this.bodyClass)) {
        this.closePanel();
      }
    });
  }

  togglePanel(toggleButton) {
    const toggleId = toggleButton.getAttribute('data-toggle-id');
    const targetPanel = document.querySelector(`${this.panelSelector}[data-toggle-id="${toggleId}"]`);
    
    const isOpen = document.body.classList.contains(this.bodyClass);
    
    if (isOpen) {
      this.closePanel();
    } else {
      this.openPanel(targetPanel);
    }
  }

  closePanel() {
    document.body.classList.remove(this.bodyClass);
    // Remove active class from all panels
    document.querySelectorAll(`${this.panelSelector}.${this.activeClass}`).forEach(panel => {
      panel.classList.remove(this.activeClass);
    });
  }

  openPanel(targetPanel) {
    document.body.classList.add(this.bodyClass);
    if (targetPanel) {
      // Remove active class from all panels first
      document.querySelectorAll(`${this.panelSelector}.${this.activeClass}`).forEach(panel => {
        panel.classList.remove(this.activeClass);
      });
      // Add active class to target panel
      targetPanel.classList.add(this.activeClass);
    }
  }
}

// Initialize the fly-out panel toggle
new FlyOutPanelToggle();

export default FlyOutPanelToggle;
